import React from 'react';

/**
 * The white panel under each block of the exam results report — Figma nodes
 * 16370:191267, 16370:191301 and 16370:191320.
 *
 * Not `Card`, which is the dashboard's: that one is drawn at the dashboard
 * frame's scale (a 15.325px radius, a 0.876px gray/200 hairline) and carries
 * the two-layer card shadow. The report's frame draws its own — a 16px radius, a
 * 1px gray/300 hairline, 24px of padding, and a single soft shadow, which the
 * file sets as a drop shadow and a rectangle shows the same as a box shadow.
 *
 * A <section> by default: each card has a heading of its own, and the page keeps
 * a landmark a screen reader can move between.
 */
const ReportCard = ({ as: Tag = 'section', className = '', children, ...rest }) => (
    <Tag
        className={
            'tw-flex tw-min-w-0 tw-flex-col tw-rounded-[16px] tw-border tw-border-solid tw-border-v2-ground-400 ' +
            `tw-bg-white tw-p-[24px] tw-shadow-v2-report ${className}`
        }
        {...rest}
    >
        {children}
    </Tag>
);

export default ReportCard;
